import {useHistory} from "react-router-dom";
import {AuthContext} from '../context/AuthContext.js'
import {GeneralesContext} from '../context/GeneralesContext.js'
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Card, CardContent, FormControl, FormControlLabel,
    Grid, IconButton, InputLabel, Radio, RadioGroup, Select as MaterialSelect,
    TextField, Tooltip, Typography, LinearProgress } from '@material-ui/core'
import TablaProveedores from './TablaProveedores.jsx';
 
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import {ErrorGeneral, llamadaApiToken, llamaApiCargaToken} from '../funciones/ClienteAxios.jsx';
import React, {useContext, useEffect, useState} from "react";
import ModalNvoProvee from './ModalNvoProvee.jsx'
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ReplayIcon from '@material-ui/icons/Replay';
import RepoTab from "./RepoTab.js";
const useStyles = makeStyles((theme) => ({
    title2: {
        fontSize: 18,
    },
    subTitle2: {
        fontSize: 12,
    },
    altura2: {
        minHeight: 70,
        marginTop: 0,
        paddingTop: 0,
    },
    altura3: {
        minHeight: 145,
        marginTop: 0,
        paddingTop: 0,
    },

}));


const CatalogoProveedor = () => {
    let history = useHistory();
    const classes = useStyles();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
 
    const {usuario, guardarUsuario} = useContext(AuthContext);
    const {guardarGenerales} = useContext(GeneralesContext);    
    const [ordenBusq, setOrdenBusq] = useState([]);
      
    const [buscar, setBuscar] = useState(true);
    const [terminal, setTerminal] = useState([]);    
    const [listProv, setListProv] = useState([])    
    const [modalNvo, setModalNvo] = useState(false);
    const [espera, setEspera] = useState(false);
 
    const [filtroAlias,setFiltroAlias] = useState("")
    const [filtroRFC,setFiltroRFC] = useState("")
    const [filtroRazon,setFiltroRazon] = useState("")
 

    useEffect(() => {                       

        const veriSesion = () => {
            const usu = localStorage.getItem('UsuarioNom');
            const nvl = localStorage.getItem('Tipo');
            if (usu === null) {
                guardarUsuario([])
                guardarGenerales([])
                localStorage.clear();
                history.push("/")
            } else {
                if (usuario.length === 0) {
                    guardarUsuario({Nombre: usu, nivel: nvl});
                }

                guardarGenerales({Titulo: 'Catálogo Proveedor'})
                               
            }
        }
        veriSesion();
        return () => {
            source.cancel();
        }
    }, []);

    useEffect(()=>{
        getListProv() 
    },[buscar])
 

    const getListProv = () => {
        setOrdenBusq([])
        const data = qs.stringify({
            Usuario: idusu,
            ip: "127.0.0.0",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/renta/proveedor";

        function respuestaListTermin(aux) {
            if (aux[0].Id !== -1) {                
                setListProv(aux)
            }
        }

        llamaApiCargaToken(data, url, respuestaListTermin, ErrorGeneral, setEspera, history, source)
    };    

 

    const onChange = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            setFiltroRFC( e.target.value.trim()
            )
        }

    };

    const onChange2 = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            
            setFiltroAlias( e.target.value.trim())
            
        }

    };

    const onChange3 = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            
            setFiltroRazon( e.target.value.trim())
            
        }

    };
    const funcionActualizar = e => {
        setBuscar(!buscar)
    };

    const onChangeTerminal = (event) => {
        setTerminal(event.target.value);
    };


    function tipoEstado(estado) {
        let auxEtiqueta = ''
        let auxColor = ''
        if (estado === 0) {
            auxEtiqueta = 'Registrado'
            auxColor = '#F46239'
        } else {
            if (estado === 1) {
                auxEtiqueta = 'Solucionado'
                auxColor = '#049b4f'
            } else {
                if (estado === -1) {
                    auxEtiqueta = 'Cancelado'
                    auxColor = 'red'
                }
            }
        }
        let renglon = {color: auxColor, etiqueta: auxEtiqueta}
        return renglon
    }

    const Encabezado = ({espacio, estiloCampo, descripcion, campo}) => {
        return (
        <Box {...espacio} >
            <Typography className={classes.title2} variant="h5" color="secondary"
                component="h2" align="center" style={estiloCampo}
            >
                {campo}
            </Typography>
            <Typography className={classes.subTitle2} color="textSecondary" align="center">
                {descripcion}
            </Typography>
        </Box>
        )
    }

    const CampoRenglon = ({estiloBox, estiloTitulo, titulo, campo}) => {
        return (
            <Box  {...estiloBox} >
                <span style={estiloTitulo}>{titulo} </span>
                <Typography variant='body'> {campo}  </Typography>
            </Box>
        )
    }

    const costadoDerecho =(orden)=>{
       
        let colorTitulo=process.env.REACT_APP_COLOR_SEC
        return(
        <span>
            <Box pl={1} my={1} >
                <Card className={classes.altura3}  >
                    <CardContent >
                        <Box display="flex" flexDirection="row"  >
                            <Encabezado espacio={{ }} estiloCampo={ {fontWeight: '900'}} 
                                descripcion={""} campo={orden.Poliza} />                                                                                                                                             
                            {/* <Encabezado espacio={{ ml:1 }} estiloCampo={ { fontWeight: '900'}} 
                                descripcion={""} campo={orden.TipoNom} />     */}                          
                            <Encabezado espacio={{ ml:1 }} estiloCampo={ { fontWeight: '900'}} 
                                descripcion={"RFC"} campo={orden.Rfc} />
                            <Encabezado espacio={{ ml:1 }} estiloCampo={ {color:orden.StCol,fontWeight:700}} 
                                descripcion={"Razon"} campo={orden.Razon} />                                                          
                        </Box>     
                        {orden.Dir.length!==0 ?
                            <CampoRenglon estiloBox={{display:"flex"}} titulo="Dirección Proveedor" campo={orden.Dir} 
                                estiloTitulo={{color:colorTitulo,fontWeight:700,paddingRight:0.2+'rem' }}
                            />                                                                                      
                        :null}               
                        {orden.Email.length!==0 ?
                            <CampoRenglon estiloBox={{display:"flex"}} titulo="Email " campo={orden.Email} 
                                estiloTitulo={{color:colorTitulo,fontWeight:700,paddingRight:0.2+'rem' }}
                            />                                                                                      
                        :null}                                              
                                                                                  
                    </CardContent>                     
                </Card>
            </Box>                    
            <RepoTab ordenBusq={orden}    />                             
        </span>)
    }
 
    const funcionActuliza = () => {
        setBuscar(!buscar)
    }

    function handleAbrir() {
        setModalNvo(true)
    }
 
    const principal = () => {
        return (
        <>
        <Grid container alignItems={'flex-start'} style={{marginTop: '.5rem', marginBottom: '.5rem'}}>
            <Grid item xs={12}>
                <Card className={classes.altura2}>
                    <CardContent style={{padding: '.5rem'}}>
                        <Box   display="flex" alignItems={'center'} flexDirection={"row"} >
                            
                            <Box  >
                                <Tooltip title="Actualizar">
                                <IconButton color="primary" size={"small"} onClick={funcionActuliza}
                                    style={{paddingTop: '.6rem'}}>
                                    <ReplayIcon/>
                                </IconButton>
                                </Tooltip>
                            </Box>                     
                            <Box  >
                                <Tooltip title="Nuevo Proveedor">
                               <IconButton size={"small"} color="primary" onClick={() => handleAbrir()}
                                    style={{paddingTop: '.6rem'}}>
                                    <AddCircleOutlineIcon/>
                                </IconButton>
                                </Tooltip>
                            </Box>    
                            {listProv.length !==0 ? 
                                <TextField id="outlined-basic" label="Filtrar por Alias" variant="outlined" size="small"
                                    name="filtroAlias" value={filtroAlias} onChange={onChange2} style={{marginRight:"1rem"}}/>
                            :null}
                            {listProv.length !==0 ? 
                                <TextField id="outlined-basic" label="Filtrar  por RFC" variant="outlined" size="small"
                                    name="filtroRFC" value={filtroRFC} onChange={onChange} style={{marginRight:"1rem"}}/>
                            :null}
                            {listProv.length !==0 ? 
                                <TextField id="outlined-basic" label="Filtrar por Razón" variant="outlined" size="small"                            
                                    name="filtroRazon" value={filtroRazon} onChange={onChange3}/>
                            :null}
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>

        <Grid container  alignItems={'flex-start'} >
            <Grid item xs={8}>
                {espera ? 
                    (<Box mt={5} ml={2}><LinearProgress/> </Box>) 
                :   <TablaProveedores                         
                        listProv={listProv}                                                
                        filtroAlias={filtroAlias}
                        filtroRFC={filtroRFC}
                        filtroRazon={filtroRazon}
                        setOrdenBusq={setOrdenBusq}
                        funcionActualizar={funcionActualizar}
                    />
                }
            </Grid>
            <Grid item xs={4}>
                {ordenBusq.length!==0 ?costadoDerecho(ordenBusq):null }
            </Grid>
        </Grid>
        </>
        )
    }

    const modNvo = modalNvo ? <ModalNvoProvee  modalAbierto={modalNvo} setModalAbierto={setModalNvo} 
        titulo={`Nuevo Proveedor`} regis={[]} actualizar={funcionActuliza} /> :null
    return (
    <>
        {modNvo}
        {principal()}
        
    </>
    )
}

export default CatalogoProveedor